import React, { ReactElement, useState } from 'react';

// Components
import useColorToolState from '../hooks/useColorToolState';
import ColorPopupContent from '../ColorPopupContent';
import CustomColorInput from '../../CustomColorInput';
import { Sheet } from '../../../../../../../mobile/structural/sheet/Sheet';

// Selectors
import { ColorToolSelectorReturnType } from '../../colorToolSelector';

// Types
import { ImMNElement } from '../../../../../../../../common/elements/elementModelTypes';
import { UseSheetReturnType } from '../../../../../../../mobile/structural/sheet/hooks/useSheet';

import './MobileColorToolContent.scss';

// Constants
import { Color } from '../../../../../../../../common/colors/colorConstants';

const MOBILE_MAX_SUGGESTED_COLORS = 7;

type MobileColorToolContentProps = ColorToolSelectorReturnType & {
    customDefaultColors?: Color[];
    customColorHandler?: (color: string | null, secondaryColor?: string | null | undefined) => void;
    customTempColorHandler?: (color: string | null, secondaryColor?: string | null | undefined) => void;
    selectedElements: Immutable.List<ImMNElement>;
    openSheet: () => void;
    closeSheet: () => void;
    sheetProps: UseSheetReturnType;
};

const MobileColorToolContent = (props: MobileColorToolContentProps): ReactElement => {
    const { customDefaultColors, openSheet, closeSheet, sheetProps } = props;
    const { isOpen } = sheetProps;

    const {
        popupColor,
        popupColorHex,
        supportColorBar,
        openCustomColorPicker,
        actualPopupMode,
        setColorPopupMode,
        supportDualColors,
        defaultColors,
        customColorInputRef,
        setColor,
        setTempColor,
        suggestedColors,
    } = useColorToolState({ ...props, isPopupOpen: isOpen });

    const [isCustomPickerOpen, setIsCustomPickerOpen] = useState(false);

    const onCustomInputBlur = () => {
        openSheet();
        setIsCustomPickerOpen(false);
    };

    const onCustomInputFocus = () => {
        closeSheet();
        setIsCustomPickerOpen(true);
    };

    const showCustomColorPickerInput = isOpen || isCustomPickerOpen;

    return (
        <>
            <Sheet {...sheetProps} className="color-tool">
                <Sheet.Overlay />
                <Sheet.Panel>
                    <Sheet.Content>
                        <ColorPopupContent
                            {...props}
                            defaultColors={customDefaultColors || defaultColors}
                            supportColorBar={supportColorBar}
                            setColor={setColor}
                            selectedColor={popupColor}
                            selectedColorHex={popupColorHex}
                            openCustomColorPicker={openCustomColorPicker}
                            colorPopupMode={actualPopupMode}
                            setColorPopupMode={setColorPopupMode}
                            supportDualColors={supportDualColors}
                            suggestedColors={suggestedColors}
                            maxSuggestedColors={MOBILE_MAX_SUGGESTED_COLORS}
                            className="p-6"
                        />
                    </Sheet.Content>
                </Sheet.Panel>
            </Sheet>
            {showCustomColorPickerInput && (
                <CustomColorInput
                    className="custom-color-picker-input"
                    ref={customColorInputRef}
                    initialColor={popupColorHex}
                    setTempColor={setTempColor}
                    setColor={setColor}
                    onBlur={onCustomInputBlur}
                    onFocus={onCustomInputFocus}
                />
            )}
        </>
    );
};

export default MobileColorToolContent;
